<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_iv"></a>NEW YORK UNIVERSITY PRESS<br/>New York and London</p>
<p class="copyright">© 1994 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>Feminist nightmares : women at odds : feminism and the problem of<br/>sisterhood / edited by Susan Ostrov Weisser and Jennifer Fleischner.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN 0-8147-2619-4.—ISBN 0-8147-2620-8 (pbk.)<br/>I. Feminism. 2. Feminism—Moral and ethical aspects.<br/>3. Feminism—United States. I. Weisser, Susan Ostrov.<br/>II. Fleischner, Jennifer.<br/>HQ1190.F4616   1994<br/>305.42—dc2o              94-26606</p>
<p class="copyright2"> CIP</p>
<p class="copyright">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="copyright">Manufactured in the United States of America</p>
<p class="copyright">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?89b066cc